import CheckIcon from "@mui/icons-material/Check";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";

import { useShipperShipmentPageContext } from "hooks";

interface Props {
  onOpenMarkAsPickedUp: () => void;
}

export function MarkShipmentAsPickedUpMenuOption(props: Props) {
  const { onOpenMarkAsPickedUp } = props;
  const { shipment } = useShipperShipmentPageContext();

  if (
    !shipment ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT" ||
    shipment.shipment_status !== "BOOKED" ||
    (shipment.access_type !== "OWNER" && shipment.access_type !== "ADMIN")
  ) {
    return null;
  }

  return (
    <ListItem>
      <Tooltip
        followCursor
        title={
          <Typography variant="body1">
            Marks a shipment as picked up.
          </Typography>
        }
      >
        <ListItemButton onClick={onOpenMarkAsPickedUp}>
          <ListItemIcon>
            <CheckIcon />
          </ListItemIcon>
          <ListItemText primary="Mark as picked up" />
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
}
